import Cookies from 'js-cookie';

// Token storage utility
export const tokenStorage = {
  // Set tokens (both localStorage and cookies for security)
  setTokens: (accessToken, refreshToken = null, user = null) => {
    // Store in localStorage for easy access
    localStorage.setItem('accessToken', accessToken);
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }

    // Store in cookies for security (httpOnly would be better but requires backend)
    Cookies.set('accessToken', accessToken, { 
      expires: 1, // 1 day
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'strict'
    });
    
    if (refreshToken) {
      Cookies.set('refreshToken', refreshToken, { 
        expires: 7, // 7 days
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'strict'
      });
    }
  },

  // Get access token
  getAccessToken: () => {
    return localStorage.getItem('accessToken') || Cookies.get('accessToken');
  },

  // Get refresh token
  getRefreshToken: () => {
    return localStorage.getItem('refreshToken') || Cookies.get('refreshToken');
  },

  // Get user data
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Clear all tokens
  clearTokens: () => {
    // Clear localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('token'); // Legacy token key

    // Clear cookies
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const accessToken = tokenStorage.getAccessToken();
    return !!accessToken;
  },

  // Check if token is expired (basic check - you might want to decode JWT for more accuracy)
  isTokenExpired: (token) => {
    if (!token) return true;
    
    try {
      // Basic JWT decode to check expiration
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      // If we can't decode the token, consider it expired
      return true;
    }
  },

  // Get token expiration time
  getTokenExpiration: (token) => {
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp ? new Date(payload.exp * 1000) : null;
    } catch (error) {
      return null;
    }
  }
};
